import { useState } from 'react'
import { api } from '../api/client'

export const useCheckProduct = () => {
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)
  const [result, setResult] = useState<any>(null)
  const [progress, setProgress] = useState<string>('')
  const [lastCheckedNmId, setLastCheckedNmId] = useState<string | null>(null)

  const check = async (description: string, attributes?: any, nmId?: string) => {
    setLoading(true)
    setError(null)
    setResult(null)
    setLastCheckedNmId(null)

    try {
      // Этап 1
      setProgress('Отправляем запрос...')
      await new Promise(r => setTimeout(r, 500))

      // Этап 2
      setProgress('Анализируем текст карточки...')

      // Делаем запрос с таймаутом 180 сек
      const controller = new AbortController()
      const timeoutId = setTimeout(() => controller.abort(), 180000)

      const response = await api.post('/rag/check', {
        product_description: description,
        product_attributes: attributes
      }, { signal: controller.signal })

      clearTimeout(timeoutId)

      // Этап 3
      setProgress('Формируем отчёт...')
      await new Promise(r => setTimeout(r, 500))

      setResult(response.data)
      setLastCheckedNmId(nmId || null)
      setProgress('')
    } catch (err: any) {
      if (err.code === 'ERR_CANCELED' || err.name === 'AbortError') {
        setError('Превышено время ожидания (180 сек). Попробуйте снова.')
      } else {
        setError(err.response?.data?.detail || 'Ошибка при проверке')
      }
      setProgress('')
    } finally {
      setLoading(false)
    }
  }

  return { check, loading, error, result, progress, lastCheckedNmId }
}